import React from 'react';

const SvgInspectionEdit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 7" {...props}>
    <path d="M6.63 1.008L5.77.143a.2.2 0 00-.283 0L0 5.635v.941c0 .11.09.2.2.2h.942L6.629 1.29a.2.2 0 000-.283z" />
  </svg>
);

export default SvgInspectionEdit;
